import styled from '@emotion/styled';

interface DropDownProps {
  children: React.ReactNode;
  label: any;
  posLeft?: string;
}

const DropDownTemplate: React.FC<DropDownProps> = ({
  label,
  children,
  posLeft,
}) => {
  return (
    <DropDownContainer>
      <DropDownLabel>{label}</DropDownLabel>
      <DropDownContentWrapper className='dropDownContent' posLeft={posLeft}>
        {children}
      </DropDownContentWrapper>
    </DropDownContainer>
  );
};

export const HoverDropDown: React.FC<DropDownProps> = (props) => {
  return <DropDownTemplate {...props} />;
};

const DropDownContainer = styled.div`
  position: relative;

  &:hover > div.dropDownContent {
    opacity: 1;
    pointer-events: auto;
  }
`;

const DropDownLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  &:hover {
    /* color: #000000a7; */

    & + div {
      animation: dropDownAnimation 0.3s ease-out;

      @keyframes dropDownAnimation {
        from {
          opacity: 0;
          transform: translateY(32px);
        }
        to {
          opacity: 1;
          transform: translateY(0px);
        }
      }
    }
  }
`;

interface DropDownContentWrapperProps {
  posLeft?: string;
}

const DropDownContentWrapper = styled.div<DropDownContentWrapperProps>`
  position: absolute;
  width: fit-content;

  /* left: ${({ posLeft }) => posLeft || '0px'}; */
  left: -180px;
  top: 99%;
  opacity: 0;
  pointer-events: none;
  z-index: 5;
  min-width: 100%;
  display: flex;

  @media (max-width: 1260px) {
    left: -300px;
  }

  @media (max-width: 1060px) {
    left: -380px;
  }
`;
